<template>
  <el-dialog :close-on-click-modal="false" :visible.sync="visible" width="min(700px, calc(100vw - 32px))">
    <template slot="title">
      <span>{{ dialogTitle }}</span>
      <span v-if="readonly && form.wareHouseId" class="title-actions">
        <el-button v-if="isAuth('base:wareHouse:update')" type="primary" size="small" @click="readonly = false">修改</el-button>
        <el-button v-if="isAuth('base:wareHouse:delete')" type="primary" size="small" @click="remove">删除</el-button>
        <el-button v-if="isAuth('base:wareHouse:Area')" type="primary" size="small" @click="$emit('open-area', form)">库区库位</el-button>
      </span>
    </template>
    <el-form ref="dataForm" :model="form" :rules="readonly ? {} : rules" :validate-on-rule-change="false" label-width="90px" @keyup.enter.native="readonly ? null : save()">
      <el-form-item label="仓库编码" prop="wareHouseCode">
        <el-input v-model="form.wareHouseCode" :disabled="readonly" placeholder="仓库编码" />
      </el-form-item>
      <el-form-item label="仓库名称" prop="wareHouseName">
        <el-input v-model="form.wareHouseName" :disabled="readonly" placeholder="仓库名称" />
      </el-form-item>
      <el-form-item label="仓库类型" prop="wareHouseClass">
        <el-select v-model="form.wareHouseClass" :disabled="readonly" placeholder="请选择仓库类型" style="width:100%">
          <el-option label="存货仓" value="0" />
          <el-option label="非存货仓" value="1" />
          <el-option label="线边仓" value="2" />
        </el-select>
      </el-form-item>
      <el-form-item label="负责人" prop="chargerList">
        <el-select v-model="chargerIds" :disabled="readonly" multiple filterable clearable placeholder="请选择负责人" style="width:100%">
          <el-option v-for="item in users" :key="item.id" :label="item.username" :value="String(item.id)" />
        </el-select>
      </el-form-item>
      <el-form-item label="地址" prop="address">
        <el-input v-model="form.address" :disabled="readonly" type="textarea" :rows="2" placeholder="地址" />
      </el-form-item>
      <el-form-item label="备注" prop="remark">
        <el-input v-model="form.remark" :disabled="readonly" type="textarea" :rows="3" placeholder="备注" />
      </el-form-item>
      <el-form-item label="启用状态" prop="isenabled">
        <el-radio-group v-model="form.isenabled" :disabled="readonly">
          <el-radio label="0">启用</el-radio>
          <el-radio label="1">禁用</el-radio>
        </el-radio-group>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">关闭</el-button>
      <el-button v-if="!readonly" type="primary" @click="save()">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import request from '../../api/request'
import { fetchPerms } from '../../api/auth'

export default {
  data() {
    return {
      visible: false, readonly: false, form: {}, users: [], chargerIds: [], permCodes: [],
      rules: {
        wareHouseCode: [{ required: true, message: '仓库编码不能为空', trigger: 'blur' }],
        wareHouseName: [{ required: true, message: '仓库名称不能为空', trigger: 'blur' }],
        wareHouseClass: [{ required: true, message: '请选择仓库类型', trigger: 'change' }],
        isenabled: [{ required: true, message: '请选择启用状态', trigger: 'change' }]
      }
    }
  },
  computed: {
    dialogTitle() {
      if (this.readonly) return '查看仓库'
      return this.form.wareHouseId ? '修改仓库' : '新增仓库'
    }
  },
  created() { fetchPerms().then(res => { this.permCodes = res.data || [] }).catch(() => {}) },
  methods: {
    isAuth(perm) {
      const user = this.$store.state.user || {}
      const codes = Array.isArray(user.roleCodes) ? user.roleCodes : []
      if (['TENANT_ADMIN', 'PLATFORM_ADMIN'].indexOf(String(user.roleCode || '')) >= 0 || codes.indexOf('TENANT_ADMIN') >= 0 || codes.indexOf('PLATFORM_ADMIN') >= 0) return true
      return this.permCodes.indexOf(perm) >= 0
    },
    init(id, readonly) {
      request.get('/sys/users').then(res => { this.users = res.data || [] }).catch(() => {})
      this.readonly = !!readonly
      this.chargerIds = []
      this.form = { isenabled: '0', wareHouseClass: '', version: 0 }
      this.visible = true
      this.$nextTick(() => { this.$refs.dataForm && this.$refs.dataForm.clearValidate() })
      if (id) this.fetchDetail(id)
    },
    fetchDetail(id) {
      request.get('/base/wareHouse/info/' + id).then(res => {
        this.form = Object.assign({ isenabled: '0' }, res.data || {})
        this.chargerIds = this.form.charger ? String(this.form.charger).split(',').map(s => s.trim()).filter(Boolean) : []
        this.$nextTick(() => { this.$refs.dataForm && this.$refs.dataForm.clearValidate() })
      }).catch(() => {})
    },
    handleConcurrentConflict(msg) {
      const text = msg || '操作失败'
      if (text.indexOf('数据已被其他用户更新') === -1 || !this.form.wareHouseId) return
      this.$confirm('当前数据已被其他用户更新，是否重新加载最新数据？', '提示', {
        confirmButtonText: '重新加载',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => { this.fetchDetail(this.form.wareHouseId) }).catch(() => {})
    },
    save() {
      this.$refs.dataForm.validate(valid => {
        if (!valid) return
        const payload = Object.assign({}, this.form, { charger: (this.chargerIds || []).join(',') })
        request.post('/base/wareHouse/' + (this.form.wareHouseId ? 'update' : 'save'), payload).then(() => {
          this.$message({
            message: '操作成功',
            type: 'success',
            duration: 1500,
            onClose: () => {
              this.visible = false
              this.$emit('refreshDataList')
            }
          })
        }).catch(err => { this.handleConcurrentConflict(err && err.message) })
      })
    },
    remove() {
      this.$confirm('确定删除该仓库？', '提示', { type: 'warning' }).then(() => {
        request.post('/base/wareHouse/delete', { wareHouseId: this.form.wareHouseId }).then(() => {
          this.$message.success('删除成功')
          this.visible = false
          this.$emit('refreshDataList')
        }).catch(() => {})
      }).catch(() => {})
    }
  }
}
</script>

<style scoped>
.title-actions { float: right; margin-right: 28px; }
</style>
